import { innerSearch } from 'api/Api';
import IframeBridge from 'IframeBridge';
import { usePaymentState } from 'payment_state/PaymentStateContext';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { findImage } from 'utils/Utils';

const ProcessingPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { paymentState, setPaymentState } = usePaymentState();
  const [tid, setTid] = useState<string>();
  const [overTime, setOverTime] = useState<boolean>(false);

  useEffect(() => {
    if (paymentState.tid !== null) {
      setTid(paymentState.tid);
    }
  }, [paymentState]);

  const updatePaymentState = infoData => {
    setPaymentState(prevState => ({
      ...prevState,
      requestCurrency: infoData.display.requestCurrency,
      requestAmount: infoData.display.requestAmount,
      reqDate: infoData.display.responseDatetime,
      orderId: infoData.response.orderId,
      resultCode: infoData.response.resultCode,
      resultMessage: infoData.response.resultMessage,
      mallReserved: infoData.response.mallReserved,
      billKey: infoData.response.billKey,
      schemeGroup: infoData.response.schemeGroup,
      schemeCode: infoData.response.schemeCode,
    }));
  };

  //InnerSearch 실행
  const transactResult = useMutation(() => innerSearch(tid), {
    onSuccess: data => {
      const resultStat = data.data.response.resultStatus;

      // 응답 processing 아니면 SelfClose
      if (resultStat !== null && resultStat !== 'PROCESSING') {
        if (isMobile) {
          updatePaymentState(data.data);
          payResult(data);
        } else {
          window.close();
        }
      }
    },
    onError: error => {
      navigate('/error');
    },
  });

  const pollingEndTransactResult = useMutation(() => innerSearch(tid), {
    onSuccess: data => {
      // PaymentState Set
      updatePaymentState(data.data);
      // InnerSearch 결과처리
      payResult(data);
      // 상태코드 예외처리
      if (
        data.data.response.resultStatus === null ||
        data.data.response.resultStatus === undefined
      ) {
        navigate('/error');
      }
    },
    onError: error => {
      navigate('/error');
    },
  });

  const payResult = data => {
    // 결과 상태
    const resultStatus = String(data.data.response.resultStatus).toLowerCase();
    // 결제 타입
    const payType = String(data.data.display.payType).toLowerCase();
    // InnerSearch 결과 값 PaymentState 설정
    setPaymentState(prevState => ({
      ...prevState,
      resultCode: data.data.response.resultCode,
      resultMessage: data.data.response.resultMessage,
      tid: data.data.response.tid,
      orderId: data.data.response.orderId,
      mallReserved: data.data.response.mallReserved,
      billKey: data.data.response.billKey,
      returnUrl: data.data.returnUrl,
      descriptor: data.data.display.descriptor,
      schemeGroup: data.data.response.schemeGroup,
      schemeCode: data.data.response.schemeCode,
    }));
    // Status에 따른 Paging 처리
    switch (resultStatus) {
      case 'success':
        navigate('/success');
        break;
      case 'decline':
        navigate('/decline');
        break;
      case 'processing':
        navigate('/processing');
        break;
      case 'pending':
        payType === 'vbank' || payType === 'otc'
          ? navigate('/vbankPending')
          : navigate('/pending');
        break;
      case 'failed':
        navigate('/failed');
        break;
      default:
        navigate('/error');
    }
  };

  useEffect(() => {
    // 폴링 실행
    const polling = setInterval(() => {
      pollingEndTransactResult.mutate();
    }, 2000);

    // 10초 뒤에 overTime 상태를 true로 업데이트
    const timeout = setTimeout(() => {
      setOverTime(true);
    }, 10000);

    return () => {
      clearInterval(polling); // 폴링 정리
      clearTimeout(timeout); // 타임아웃 정리
    };
  }, [tid]); // `tid`가 변경될 때마다 실행

  const handleAllClose = e => {
    e.preventDefault();
    const returnObject = {
      resultStatus: 'PROCESSING',
      resultCode: paymentState.resultCode,
      resultMessage: paymentState.resultMessage,
      tid: paymentState.tid,
      orderId: paymentState.orderId,
      mallReserved: paymentState.mallReserved,
      returnUrl: paymentState.returnUrl,
      schemeGroup: paymentState.schemeGroup,
      schemeCode: paymentState.schemeCode,
    };

    if (isMobile) {
      const url = new URL(paymentState.returnUrl);
      const params = new URLSearchParams(url.search);

      params.set('resultStatus', 'PROCESSING');
      params.set(
        'resultCode',
        paymentState.resultCode ? paymentState.resultCode : '',
      );
      params.set(
        'resultMessage',
        paymentState.resultMessage ? paymentState.resultMessage : '',
      );
      params.set('tid', paymentState.tid);
      params.set('orderId', paymentState.orderId);
      params.set(
        'mallReserved',
        paymentState?.mallReserved ? paymentState.mallReserved : '',
      );
      params.set(
        'schemeGroup',
        paymentState?.schemeGroup ? paymentState.schemeGroup : '',
      );
      params.set(
        'schemeCode',
        paymentState?.schemeCode ? paymentState.schemeCode : '',
      );
      window.location.href = url + '?' + params;
    } else {
      window.sessionStorage.removeItem('auth');
      window.sessionStorage.removeItem('mid');
      window.sessionStorage.removeItem('clientKey');
      IframeBridge.sendViewOff(returnObject);
    }
  };

  return (
    <>
      <div className="completed">
        <div className="middle">
          <div className="icon">
            <img src={findImage('receive.png')} />
          </div>
          <div className="title">{t('payment_decline_uc')}</div>
          <div className="text" style={{ whiteSpace: 'pre-line' }}>
            {t('payment_processing_polling')}
          </div>
          <div
            className="loading-section"
            style={{ height: 120, marginBottom: -50, marginTop: 30 }}
          >
            <div className="white-spin" />
          </div>
        </div>
      </div>
      <div
        className="completed-btn"
        style={{ height: overTime ? undefined : 50 }}
      >
        <div className="box confirmBox">
          {overTime && (
            <button className="all-close" onClick={handleAllClose}>
              {t('close')}
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default ProcessingPage;
